export default __webpack_public_path__ + "static/media/coin.8c363244.png";